//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Annotations.js";
import "../no/TaggedObjectCollection.js";
import "../no/ugmath.js";
import "../Annotations/Annotations.AnnotationManager.js";
let d=[[],[[[],"NewTargetData",{R_:{target_data:"Annotations.DatumTargetData"}},0,0],[[],"NewRectangularTargetData",{R_:{target_data:"Annotations.RectangularTargetData"}},0,0],[[],"NewCircularTargetData",{R_:{target_data:"Annotations.CircularTargetData"}},0,0],[[],"NewArbitraryTargetData",{R_:{target_data:"Annotations.ArbitraryTargetData"}},0,0],[["target_data","pmi_data","annotation_plane","origin","leader"],"CreatePointTarget",{R_:{point_target:"Annotations.PointTarget"}},5,0],[["target_data","origin","leader"],"CreatePointTarget1",{R_:{point_target:"Annotations.DraftingPointTarget"}},3,0],[["target_data","pmi_data","annotation_plane","origin","leader"],"CreateLineTarget",{R_:{line_target:"Annotations.LineTarget"}},5,0],[["target_data","origin","leader"],"CreateLineTarget1",{R_:{line_target:"Annotations.DraftingLineTarget"}},3,0],[["target_data","pmi_data","annotation_plane","origin","leader"],"CreateRectangularTarget",{R_:{rectangular_target:"Annotations.RectangularTarget"}},5,0],[["target_data","data","annotation_plane","origin","leader"],"CreateCircularTarget",{R_:{circular_target:"Annotations.CircularTarget"}},5,0],[["target_data","data","annotation_plane","origin","leader"],"CreateArbitraryTarget",{R_:{arbitrary_target:"Annotations.ArbitraryTarget"}},5,0],[["target_data","origin","leader"],"CreateArbitraryTarget1",{R_:{arbitrary_target:"Annotations.DraftingArbitraryTarget"}},3,0]],[]];
SPLM.Annotations.DatumTargetCollection = class extends SPLM.TaggedObjectCollection{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.Annotations.DatumTargetCollection";
        SPLM.c$d(this.Class,d);d=[];
    }
    ToArray(context)
    {
        let r={};
        if(context === undefined){
            r.ToArray={"context":this._d.ObjectId};
        }
        else{
            r.ToArray={"context":context};
        }
        r.Class=this._d.Class;
        if(SPLM.api === undefined){
            this._d.ToArray=r.ToArray;
        }
        else{
            SPLM.api.push(r);
        }
        return r;
    }
};

export default SPLM;